// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3em03","Footer-List":"Footer_Footer-List__xzt4C","Footer-Item":"Footer_Footer-Item__10Yfo","Footer-Link":"Footer_Footer-Link__y2nei"};